import { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
import { useState, useEffect } from "react";
import { Card, Box } from "@mui/material";
import { BaseOptionChart } from "../../charts";
import { fNumber } from "../../../utils/formatNumber";
import { fa } from "faker/lib/locales";

function AppTypes(props) {
  const [prescXaxis, setPrescXaxis] = useState(2500);

  const [CHART_DATATypes, setCHART_DATATypes] = useState([]);
  const [CHART_NAMES, setCHART_NAMES] = useState([]);


  useEffect(() => {
    if (props.prescriptions.types) {
      const data = props.prescriptions.types.map((item) => item.y);
      const data2 = props.prescriptions.types.map((item) => item.x);
      setCHART_DATATypes([{ data }]);
      setCHART_NAMES(data2);
      const maxValue = Math.max(...data);
      const total = maxValue *1.3; // Add some padding to the max value
      setPrescXaxis(total)
    };
  }, [props.prescriptions.types]);

  const chartOptions_TypesBar = merge(BaseOptionChart(), {
    tooltip: {
      marker: { show: false },
      followCursor: true,
      y: {
        formatter: function (val) {
          const total = CHART_DATATypes[0].data.reduce((acc, curr) => acc + curr, 0);
          const percentage = ((val / total) * 100).toFixed(0);
          return `${percentage}%`;
        },
        title: { formatter: () => "Percentage of all consultations:" },
      },
    },
    grid: { borderColor: "transparent" },
    colors: ["#3E8397"],
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: { position: "top" },
        columnWidth: "50%",
      },
    },
    legend: { show: false },
    dataLabels: {
      formatter: (val) => fNumber(val),
      enabled: true,
      style: { colors: ["#708090"] },
      offsetX: 35,
    },
    xaxis: {
      categories: CHART_NAMES,
      min: 0,
      max: prescXaxis,
      tickAmount: 5,
      show: false,
    },
    yaxis: {
      labels: { style: { colors: "#22577A" } },
    },
  });

  return (
    <Card sx={{ boxShadow: "none", mt: 4 }}>
      <Box sx={{ mx: 1 }} dir="ltr">
        <ReactApexChart
          type="bar"
          series={CHART_DATATypes}
          options={chartOptions_TypesBar}
          height={500}
        />
      </Box>
    </Card>
  );
}

import { connect } from "react-redux";
const mapState = state => ({
  prescriptions: state.overview.prescriptions
 });
 
 const mapDispatch = ({ 
  overview: {loadData}}) => ({
    loadData: () => loadData()
 });
 
 export default connect(mapState, mapDispatch)(AppTypes);
